module.exports = __webpack_public_path__ + "img/399.63f72e9c.jpg";